// import components
import BacklogFilters from '../BacklogFilters';
import BacklogViewSettings from '../BacklogViewSettings';

// import external libraries
import { memo } from 'react';

// import styles
import { BacklogSlotContainer } from '../../Backlog.styles';

// import types
import type { BacklogToolbarControlsProps } from './BacklogToolbarControls.types';

/**
 * The two backlog toolbar controls, side by side on the left: a sliders icon that opens the activity
 * and care receiver filters, and an eye icon that opens the view settings. Each opens its settings in
 * a popper on press, the way the flex match toolbar behaves.
 *
 * One slot component rather than two, so the toolbar's injected isRightPositioned reaches both — the
 * toolbar clones a single element per slot, so the flag would otherwise stop at a fragment.
 */
const BacklogToolbarControls = ({
  activityOptions,
  selectedActivityOptions,
  onActivityCodesChange,
  careReceiverOptions,
  selectedCareReceiverOptions,
  onCareReceiverIdsChange,
  cellValueMode,
  onCellValueModeChange,
  showTotals,
  onShowTotalsChange,
  showCompleted,
  onShowCompletedChange,
  isRightPositioned
}: BacklogToolbarControlsProps) => (
  // Docked to the right the toolbar runs vertically, so the two icons stack instead of sitting in a row.
  <BacklogSlotContainer isVertical={isRightPositioned}>
    <BacklogFilters
      activityOptions={activityOptions}
      selectedActivityOptions={selectedActivityOptions}
      onActivityCodesChange={onActivityCodesChange}
      careReceiverOptions={careReceiverOptions}
      selectedCareReceiverOptions={selectedCareReceiverOptions}
      onCareReceiverIdsChange={onCareReceiverIdsChange}
      isRightPositioned={isRightPositioned}
    />
    <BacklogViewSettings
      cellValueMode={cellValueMode}
      onCellValueModeChange={onCellValueModeChange}
      showTotals={showTotals}
      onShowTotalsChange={onShowTotalsChange}
      showCompleted={showCompleted}
      onShowCompletedChange={onShowCompletedChange}
      isRightPositioned={isRightPositioned}
    />
  </BacklogSlotContainer>
);

export default memo(BacklogToolbarControls);
